module.exports = __webpack_public_path__ + "static/media/sdvosb.235cc444.png";